module.exports = __webpack_public_path__ + "img/20191127171706_8452.a8379a6f.jpg";